import { render, staticRenderFns } from "./FlowMove.vue?vue&type=template&id=24f35dc9&scoped=true"
import script from "./FlowMove.vue?vue&type=script&lang=js"
export * from "./FlowMove.vue?vue&type=script&lang=js"
import style0 from "./FlowMove.vue?vue&type=style&index=0&id=24f35dc9&prod&lang=less"
import style1 from "./FlowMove.vue?vue&type=style&index=1&id=24f35dc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f35dc9",
  null
  
)

export default component.exports